class MixMatchBogo extends HTMLElement {
  constructor() {
    super();
    this.mixMatchBogoId = this.getAttribute('data-mix-match-bogo-id');
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.toggles = this.querySelectorAll('[data-mix-match-bogo-toggle]');
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('change', this.handleChange);
    });
  }

  disconnectedCallback() {
    this.toggles?.forEach((toggle) => {
      toggle.removeEventListener('change', this.handleChange);
    });
  }

  handleChange(event) {
    const value = event.currentTarget.value;
    const wrapper = this.querySelector(`[data-mix-match-bogo-wrapper-${value}]`);
    if (!wrapper) return;
    wrapper.classList.remove('hidden');

    const otherWrapper = this.querySelector(`[data-mix-match-bogo-wrapper-${value === 'a' ? 'b' : 'a'}]`);
    if (otherWrapper) otherWrapper.classList.add('hidden');

    wrapper.querySelector('product-gwp')?.handleVariantChange();
  }
}

if (!customElements.get('mix-match-bogo')) {
  customElements.define('mix-match-bogo', MixMatchBogo);
}
